export const showLoader = () => {
	const loaderContainer = document.getElementById('loader-container');
	if (!loaderContainer) return
	loaderContainer.classList.remove('hidden');
}
